import { Analytics } from '@plaudit/analytics';
import * as $ from 'jquery';
// import 'jquery-colorbox'; 

// const colorboxDefaults = {
// 	transition: 'fade',
// 	fixed: true,
// 	width: 1280,
// 	height: 720,
// 	opacity: .75,
// 	scalePhotos: true,
// 	maxWidth: '95%',
// 	maxHeight: '95%',
// 	initialWidth: 500,
// 	initialHeight: 300,
// 	close: '<span>Close</span>'
// };
export default class Gallery {
	constructor() {
		const selector_gallery = '.gallery';
		const selector_viewer = '.gallery__view';
		const selector_thumbs = '.gallery__thumb';
		const selector_media = '.image';

		let $gallery = jQuery(selector_gallery);
		if ($gallery.length === 0) {
			return;
		}

		const analytics = Analytics.getInstance();
		const trackControlEvent = (label: string) => analytics.trackEvent('Image Gallery', 'Control Click', label);
		// const colorboxConfig = jQuery.extend({}, colorboxDefaults, {
		// 	iframe: true
		// });

		$gallery.each((index, element) => {
			let currentIndex = 0;
			let removeOldMediaTimeoutID: number = undefined;
			const $elem = jQuery(element);
			const $galleryView = $elem.find(selector_viewer);
			const $galleryThumbs = $elem.find(selector_thumbs);

			function removeOldMedia(): void {
				// Remove all but first one
				let $mediaElements = $galleryView.find(selector_media);
				for (let i=1; i < $mediaElements.length; ++i) {
					jQuery($mediaElements[i]).remove();
				}
				$galleryView.attr('data-status', '');

				removeOldMediaTimeoutID = undefined;
			}

			/**
			 * Activates selected and deactivates others
			 * @param {number} newIndex The index of the slide to activate
			 */
			function activateByIndex(newIndex: number): void {
				currentIndex = newIndex;

				const $thumb = jQuery($galleryThumbs[newIndex]);
				const $image = $thumb.find('a.image');
				const $video = $thumb.find('a.video');
				const imageHref = $image.attr('href');
				const $galleryMedia = $galleryView.find(selector_media);

				if ($galleryMedia.attr('src') !== imageHref) {
					if (removeOldMediaTimeoutID !== undefined) {
						clearTimeout(removeOldMediaTimeoutID);
					}

					// Remove 'active' class from all thumbnails and then add to current
					$galleryThumbs.attr('data-status', '');
					$thumb.attr('data-status', 'active');

					// Load the new media
					$galleryView.attr('data-status', 'loading');
					let alt = $image.find('img').attr('alt') || ' ';

					const newImageParts = [];
					newImageParts.push(`<div class="${ $image.attr('class') }">`);
					newImageParts.push(`<img src="${ imageHref }" alt="${ alt }" />`);
					// if ($video.length !== 0) {
					// 	/* strips any colorbox classes before reuse */
					// 	var newVideo = $video.clone().removeClass('cboxElement').attr('rel', '').get(0).outerHTML;
					// 	newImageParts.push( newVideo );
					// }
					newImageParts.push(`</div>`);
					const newImage = newImageParts.join('');

					$galleryView.prepend(jQuery(newImage));

					// $galleryView.on('click', 'a.video', function(event){
					// 	event.preventDefault();
					// 	jQuery(event.target).colorbox(colorboxConfig);
					// });

					// Have media removing removed once done
					removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
				}
			}

			// Set up thumbnail clicks
			function thumbClickHandler(event: JQueryMouseEventObject): void {
				event.preventDefault();

				const newIndex = jQuery(this).parent('.gallery__thumb').index();
				activateByIndex(newIndex);

				trackControlEvent('Thumbnail');
			}
			$galleryThumbs.on('click', 'a', thumbClickHandler);

			function createControls() {
				const controlsFragment = DocumentFragment;
				const controls = document.createElement('div');
				controls.innerHTML = '\
				<div class="gallery__controls">\
					<button type="button" class="gallery__control control--prev"><span>Previous</span></button>\
					<button type="button" class="gallery__control control--next"><span>Next</span></button>\
				</div>\
				';
				$galleryView.append(controls);
			}
			function createControlsEventHandlers() {
				// Set up "previous" button click
				const $prevEl = $elem.find('button[class*="--prev"]');
				const prevClickHandler = (event: JQueryMouseEventObject) => {
					const newIndex = currentIndex
						? currentIndex - 1
						: $galleryThumbs.length - 1;

					activateByIndex(newIndex);
					trackControlEvent('Previous');
				};
				$prevEl.on('click', prevClickHandler);

				// Set up "next" button click
				const $nextEl = $elem.find('button[class*="--next"]');
				const nextClickHandler = (event: JQueryMouseEventObject) => {
					const newIndex = currentIndex < $galleryThumbs.length - 1
						? currentIndex + 1
						: 0;

					activateByIndex(newIndex);
					trackControlEvent('Next');
				};
				$nextEl.on('click', nextClickHandler);
			}

			if ($galleryThumbs.length > 1){
				createControls();
				createControlsEventHandlers();
			}
		});
	}
}
